import api from "../../services/api"

async function verifyUser() {

    try {

        const user = (await api.get("user/verify")).data

        return user


    } catch (e) {
        return e
    }

}

export { verifyUser }